import { useWorkflowStore } from '@/stores/workflowStore';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

export function WorkflowSelector() {
  const { workflows, currentWorkflow, setCurrentWorkflow } = useWorkflowStore();

  const handleSelectWorkflow = (workflowId: string) => {
    const workflow = workflows.find((w) => w.id === workflowId);
    if (workflow) {
      setCurrentWorkflow(workflow);
    }
  };

  if (workflows.length === 0) {
    return null;
  }

  return (
    <Select value={currentWorkflow?.id || ''} onValueChange={handleSelectWorkflow}>
      <SelectTrigger className="w-64">
        <SelectValue placeholder="Select a workflow" />
      </SelectTrigger>
      <SelectContent>
        {workflows.map((workflow) => (
          <SelectItem key={workflow.id} value={workflow.id}>
            {workflow.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
